import React, { useCallback, useEffect, useState } from 'react';
import NewsCard from './NewsCard';
import { buildApiUrl } from '../utils/api/config';
import './RelatedNews.css';

/**
 * RelatedNews Component
 * Displays news items related to the current news
 */
function RelatedNews({ newsId }) {
  const [relatedNews, setRelatedNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRelatedNews = useCallback(async () => {
    if (!newsId) return;

    try {
      setLoading(true);
      const response = await fetch(buildApiUrl(`/news/related/${newsId}?limit=4`));
      const data = await response.json();
      
      if (data.success) {
        setRelatedNews(data.data);
      }
    } catch (error) {
      console.error('Error fetching related news:', error);
      setError('Unable to load related news');
    } finally {
      setLoading(false);
    }
  }, [newsId]);

  useEffect(() => {
    fetchRelatedNews();
  }, [fetchRelatedNews]);

  if (loading) {
    return <div className="related-news loading">लोड हो रहा है...</div>;
  }

  if (error || relatedNews.length === 0) {
    return null;
  }

  return (
    <section className="related-news-section">
      <h3 className="related-news-title">संबंधित समाचार</h3>
      <div className="related-news-grid">
        {relatedNews.map((news, index) => (
          <div key={news._id || index} className="related-news-item">
            <NewsCard news={news} variant="related" />
          </div>
        ))}
      </div>
    </section>
  );
}

export default RelatedNews;
